import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import imageAnimeted from "../Layout/imgs/animated_loop_500x600.gif"
import imageAnimetedC from "../Layout/imgs/animated_looped_500px.gif"
import imgProductLakay from '../Layout/imgs/md3.jpg' 
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./mystyle.sliderProduct.css"
import useElakaySwiper from "./swiperSettings/useElakaySwiper";
import { legacyTableFrom } from "./swiperSettings/swiperSettingsModel";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["loadindSwiper"]?.[key] || fallback;

const LoadingSwiper = (props)=>{

  const {
    circle = false,
    classCard0 =  'justify-content-center',
    myStyles,
    wm0 = 2,
    wm640 = 3,
    wm768 = 4,
    wm1024= 5,
   wm1200 = 6,
    swiperOptions,
  } = props
  let arrayLong = 6
  // Options: page instance > Animation Settings -> Swiper Settings > origin.
  const swp = useElakaySwiper("loadingSlider", {
    swiperOptions,
    legacyTable: legacyTableFrom({ wm0, wm640, wm768, wm1024, wm1200 }, { 0: 10 }),
    legacyExplicit: ["wm0", "wm640", "wm768", "wm1024", "wm1200"].some((key) => props[key] !== undefined),
    slideCount: arrayLong,
  });
const cells = [];   
    const loadingImg = () => {
        for (let j = 0; j < arrayLong; j++) {
       cells.push( <SwiperSlide key={j} >
        <div className={circle? `card m-2 p-0 rounded-circle`: `card`}>
          <img
          className={circle? "rounded-circle" : "cembla__slide__img"}
              // className="card-img-top"
              src={circle?imageAnimetedC :imageAnimeted}
              onError={event => {
                  event.target.src = imgProductLakay
                  event.onerror = null
                }}
              alt={__elakayText("t001", "loadindImgAminated")}
              style={{ height: "100%", width: "100%" }}
          /> 
          </div>
          </SwiperSlide>)
            }
            }
let style = circle ?{} :myStyles
  return (
  <div className={`mt-4  p-2`} style={style} >
      <Swiper
        key={swp.key}
        {...swp.swiperProps}
        style={{
          "--swiper-navigation-color": "#007399",
          "--swiper-pagination-color": "#007399",
          ...swp.style,
        }}
        className={`mySwiper ${swp.className}`}
      >
        {loadingImg()}
        {cells}
      </Swiper>

  </div>
  )

}

export default LoadingSwiper; 